import { render, staticRenderFns } from "./ImageGalleryDialog.vue?vue&type=template&id=2b47aeb6&scoped=true&lang=pug&"
import script from "./ImageGalleryDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageGalleryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGalleryDialog.vue?vue&type=style&index=0&id=2b47aeb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47aeb6",
  null
  
)

export default component.exports